export default "__VITE_ASSET__kLOceqal__"